<svelte:options runes={true} />

<script lang="ts">
	import { create } from "@bufbuild/protobuf";
	import { Modal } from "flowbite-svelte";
	import { createEventDispatcher } from "svelte";
	import type { SchemaProperty } from "#gen/abacus/v2/abacus_pb.js";
	import { ChoiceFieldPropertiesSchema, FieldPropertiesSchema, FieldType } from "#gen/forms/v1/field_pb.js";
	import Icon from "#lib/components/Icon.svelte";
	import P from "#lib/components/P.svelte";
	import { getTypeIcon, getValidFieldTypes } from "#lib/components/page/components/form/fieldTypes.js";
	import Button from "#lib/ui/Button/index.js";

	interface Props {
		open: boolean;
		pendingPropertyToConnect: SchemaProperty | undefined;
	}

	let { open = $bindable(), pendingPropertyToConnect }: Props = $props();

	let suggestedField = $derived(pendingPropertyToConnect ? getValidFieldTypes(pendingPropertyToConnect.type)[0] : undefined);
	let typeIcon = $derived(suggestedField ? getTypeIcon(suggestedField.type, suggestedField.type === FieldType.CHOICE ? create(FieldPropertiesSchema, { properties: { case: "choice", value: create(ChoiceFieldPropertiesSchema, { choiceType: suggestedField.choiceType, choices: [{ value: "Option 1" }] }) } }) : undefined) : undefined);
	let expectedTypeString = $derived(typeIcon?.title?.toLowerCase() ?? "different");

	const dispatch = createEventDispatcher();

	function onClose() {
		open = false;
	}

	function onUseSuggestedField() {
		dispatch("confirm");
		onClose();
	}
	//
</script>

<Modal {open} on:close={onClose} class="max-w-[416px]">
	<div class="mt-6 flex flex-col items-center gap-6 px-2 pb-1">
		<P class="font-medium" size="sm">Use the suggested field instead?</P>
		<P size="xs" class="text-center">Looks like the contact property you selected expects {["a", "e", "i", "o", "u"].includes(expectedTypeString.substring(0, 1)) ? "an" : "a"} {expectedTypeString} input. Did you mean to use {["a", "e", "i", "o", "u"].includes(expectedTypeString.substring(0, 1)) ? "an" : "a"} {expectedTypeString} field?</P>
		{#if typeIcon}
			<div class="flex flex-row items-center gap-2">
				<div class="rounded-lg p-2 text-center" style="background-color: {typeIcon.accentColor};">
					<Icon name={typeIcon.icon} iconSet={typeIcon.iconSet} class="m-auto h-5 w-5" />
				</div>
				<P size="sm" class="font-medium">{typeIcon?.title}</P>
			</div>
		{/if}
	</div>
	<div class="flex w-full flex-row items-center justify-center gap-4">
		<Button size="xs" data-action-name="no-link-another-property" color="alternative" on:click={onClose}>No, I’ll link another property</Button>
		<Button size="xs" data-action-name="use-suggested-field" on:click={onUseSuggestedField}>Use suggested field</Button>
	</div>
	<svelte:fragment slot="footer" />
</Modal>
